<div class="main-container">
  <div class="container-fluid p-0">
    <div class="row g-0 layout-row">

      <!-- LEFT INFO PANEL -->
      <div class="col-lg-3 col-12 info-panel">
        <div class="panel-header">
          <div class="logo-placeholder">WFLEET</div>
          <div class="live-badge">
            <span class="live-dot"></span>
            LIVE
          </div>
        </div>

        <div class="panel-content">
          <div class="eta-section">
            <div class="eta-label-row">
              <span class="eta-dash"></span>
              <span class="eta-label-text">ESTIMATED ARRIVAL</span>
            </div>
            <div class="eta-value-row">
              <span class="eta-number">---</span>
              <div class="eta-right">
                <span class="eta-unit">min</span>
              </div>
            </div>
            <p class="order-status-text">Order is <strong>Loading...</strong></p>
          </div>

          <div class="panel-section">
            <h6 class="section-label">DRIVER</h6>
            <div class="driver-row">
              <div class="driver-avatar">
                <span class="avatar-letter">?</span>
              </div>
              <div class="driver-info">
                <p class="driver-name">---</p>
                <p class="driver-phone">---</p>
              </div>
            </div>
          </div>

          <div class="panel-section">
            <h6 class="section-label">TRIP INFO</h6>
            <div class="trip-cards-row">
              <div class="trip-card">
                <div class="trip-icon-wrap trip-icon-blue"><i class="bi bi-clock"></i></div>
                <p class="trip-label">ETA</p>
                <div class="trip-value-row">
                  <span class="trip-value">---</span>
                  <span class="trip-unit">min</span>
                </div>
              </div>
              <div class="trip-card">
                <div class="trip-icon-wrap trip-icon-green"><i class="bi bi-bag"></i></div>
                <p class="trip-label">AMOUNT</p>
                <div class="trip-value-row">
                  <span class="trip-value">---</span>
                  <span class="trip-unit">KWD</span>
                </div>
              </div>
              <div class="trip-card">
                <div class="trip-icon-wrap trip-icon-orange"><i class="bi bi-box-seam"></i></div>
                <p class="trip-label">PACKAGE</p>
                <div class="trip-value-row">
                  <span class="trip-value">×0</span>
                  <span class="trip-unit">item</span>
                </div>
              </div>
            </div>
          </div>

          <div class="panel-section">
            <h6 class="section-label">ROUTE</h6>
            <div class="route-section">
              <div class="route-item">
                <div class="route-dot-wrap"><span class="route-dot pickup-dot"></span></div>
                <div class="route-item-info">
                  <span class="route-item-label">PICKUP POINT</span>
                  <p class="route-item-addr">---</p>
                </div>
              </div>
              <div class="route-connector"></div>
              <div class="route-item">
                <div class="route-dot-wrap"><span class="route-dot dropoff-dot"></span></div>
                <div class="route-item-info">
                  <span class="route-item-label">DROP-OFF POINT</span>
                  <p class="route-item-addr">---</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- RIGHT MAP PANEL -->
      <div class="col-lg-9 col-12 map-panel">
        <div id="map" class="map-container"></div>
        <div class="map-taskid-badge">Loading...</div>
      </div>

    </div>
  </div>
</div>
